import { SvgIcon } from "material-ui";
import React from "react";

const BackLeftIcon = props => (
  <SvgIcon {...props} stroke={props.color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 408">
    <path d="M408 178.5H96.9L239.7 35.7 204 0 0 204l204 204 35.7-35.7L96.9 229.5H408v-51z" />
  </SvgIcon>

);

export default BackLeftIcon;



// WEBPACK FOOTER //
// ./src/icons/BackLeftIcon.jsx